<template>
  <Teleport to="body">
    <div
      data-toup=""
      class="to-up"
      :class="{ 'is--active': isActive }"
      @click="scrollToTop"
    >
      <div class="to-up__inner">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 24 24" fill="none" class="to-up__icon-24">
          <path d="M18 14L12 8L6 14" stroke="white" stroke-linecap="round"></path>
        </svg>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";

const isActive = ref(false);

const handleScroll = () => {
  const scrollY = window.scrollY || window.pageYOffset;
  isActive.value = scrollY > 500;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  handleScroll();
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
:global(.to-up) {
  z-index: 60;
  cursor: pointer;
  background: #0f0f0f;
  border: 0;
  border-radius: 50%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  justify-content: center;
  align-items: center;
  width: 4.425em;
  height: 4.425em;
  min-width: 4.425em;
  min-height: 4.425em;
  max-width: 4.425em;
  max-height: 4.425em;
  aspect-ratio: 1 / 1;
  opacity: 0;
  pointer-events: none;
  transform: translateY(0.75em) scale(0.94);
  transition: opacity 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;
  display: flex;
  position: fixed;
  right: 1.25em;
  bottom: calc(1.25em + 4.425em + 0.75em + env(safe-area-inset-bottom));
  box-shadow: 0 0.85em 2em rgba(15, 15, 15, 0.22);
}

:global(.to-up:hover) {
  background: #1c1c1c;
  box-shadow: 0 1em 2.4em rgba(15, 15, 15, 0.28);
  transform: translateY(-0.15em) scale(1);
}

:global(.to-up__inner) {
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
}

:global(.to-up__icon-24) {
  width: 1.75em;
  height: 1.75em;
}

:global(.to-up.is--active) {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0) scale(1);
}

@media screen and (max-width: 479px) {
  :global(.to-up) {
    width: 4em;
    height: 4em;
    min-width: 4em;
    min-height: 4em;
    max-width: 4em;
    max-height: 4em;
    right: 1em;
    bottom: calc(1em + 4em + 0.75em + env(safe-area-inset-bottom));
  }

  :global(.to-up__icon-24) {
    width: 1.55em;
    height: 1.55em;
  }
}
</style>
